module.exports = __webpack_public_path__ + "static/media/destacados-5.5bd35a72.png";